/**
 * @author PoornaChandu
 * @description  Planned Hours for Device  is Scheduled
 */
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import localStorage from '../../../utils/localStorage';
import { API_PLANNEDHOURS } from '../../../commons/api';
import StyledTable from '../../../commons/styles/table';
import { DrawerFooter } from '../../../commons/styles/layout';
import { CreatePlannedHours, UpdatePlannedHours } from '../APICalls';
import { Form, Input, message, Button, Drawer, Tooltip, Select, DatePicker, Modal, Checkbox } from 'antd';
import {
    EditOutlined,
    PlusOutlined,
    UpSquareOutlined,
    SearchOutlined,
    EyeOutlined
} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import translation from '../Utils/translation';
import HierarchyModal from '../Utils/HierarchyModalPH';
import PlannedHoursForm from '../Utils/PlannedHoursInput';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { isArray } from 'lodash';
import DatePlannedHours from '../Utils/DatePlannedHours';

const { Option } = Select;
const { TextArea } = Input;
dayjs.extend(utc);
const ParameterSelection = (props) => {
    const [translationCache, setTranslationCache] = useState(props.translationCache);
    const [visibleAttributes, setVisibleAttributes] = useState(false);
    const [typeChangeModal, setTypeChangeModal] = useState(false);
    const [dateplannedHours, setDateplannedHours] = useState([]);
    // const [popVisible, setPopVisible] = useState(false);
    const [hierarchydata, setHierarchyData] = useState([]);
    const [treeVisible, setTreeVisible] = useState(false);
    // const [isChecked, setIsChecked] = useState(false);
    const [checkedValue, setCheckedValue] = useState([]);
    const [plannedHours, setPlannedHours] = useState({});
    const [modulesList, setModulesList] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [formObject, setFormObject] = useState({});
    const [disabled, setDisabled] = useState(true);
    const [status, setStatus] = useState(false);
    const [type, setType] = useState('Device');
    const [title, setTitle] = useState('Create PlannedHours');
    const [list, setList] = useState([]);
    const [code, setCode] = useState([]);
    const [close, setClose] = useState(false);
    const searchInput = useRef(null);
    const hForm = useRef(null);

    useEffect(() => {
        if (isArray(plannedHours)) {
            let newValue = {};
            plannedHours.map(item => {
                const [day, hours] = item.split(': ');
                newValue[day] = parseFloat(hours);
                return newValue;
            }
            );
            setPlannedHours(newValue);
        }
    }, [formObject.Id]);

    useEffect(() => {
        _getList();
    }, []);

    useEffect(() => {
        if (props.translationCache !== translationCache) {
            setTranslationCache(props.translationCache);
        }
    }, [props.translationCache, translationCache]);

    const addedTagList = (day, hour) => {
        const hours = parseFloat(hour);

        hForm && hForm.current.setFieldsValue({ [day]: hours });


        setPlannedHours(prevState => ({
            ...prevState,
            [day]: hours
        }));
    };

    const closeTagList = (tagsArray) => {
        const newValue = {};

        tagsArray.forEach(item => {
            const [day, hourString] = item.split(': ');
            const hours = parseFloat(hourString);
            if (!isNaN(hours)) {
                newValue[day] = hours;
            }
        });

        setPlannedHours(newValue);
    };
    const addedDateTagList = (day, hour, date) => {

        let NewDatePlannedhour = {
            StartDate: dayjs.utc(date).format('YYYY-MM-DD 18:30:00'),
            EndDate: dayjs.utc(date).format('YYYY-MM-DD 18:29:59'),
            PlannedHours: hour
        };

        setDateplannedHours((prevState) => [
            ...prevState,
            NewDatePlannedhour
        ]);

    };


    const closeDateTagList = (tagsArray) => {

        const removedKeys = new Set(
            tagsArray.map(tagStr => {
                const [dateStr, hoursPart] = tagStr.split(': ');
                const hours = parseFloat(hoursPart);
                return `${dateStr}-${hours}`;
            })
        );

        const filteredDateplannedHours = dateplannedHours.filter(({ StartDate, PlannedHours }) => {
            const day = dayjs.utc(StartDate).format('YYYY-MM-DD');
            const key = `${day}-${PlannedHours}`;
            return !removedKeys.has(key);
        });

        setDateplannedHours(filteredDateplannedHours);

    };
    //    const getHierarchyData = async () => {
    //     let hierarchyCode = props.defaultHiearchy?.HierarchyCode;
    //     const hierarchyApi = await getHierarchyLevels(hierarchyCode);
    //     setHierarchy(hierarchyApi);
    // };
    const getModuleList = () => {
        const siteId = localStorage.get('currentSite');
        const accessToken = localStorage.get('accessToken');
        let url = `/api/rubusMaster/modules/get?Status=Active&SiteId=${siteId}`;

        let orgHeaders = {
            method: 'GET',
            url,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };
        axios(orgHeaders)
            .then((response) => {
                setModulesList(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    const getHierarchyData = (module) => {
        const siteId = localStorage.get('currentSite');
        const accessToken = localStorage.get('accessToken');
        let url = `/api/hierarchymodule/getSubDevicesByModule?SiteId=${siteId}&HierarchyCode=${props.defaultHiearchy?.HierarchyCode}&Module=${module}`;

        let orgHeaders = {
            method: 'GET',
            url,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };
        axios(orgHeaders)
            .then((response) => {
                setHierarchyData(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    const onModalsOk = (e) => {
        e.preventDefault();
        setCheckedValue(checkedValue);
        setCode(checkedValue);
        setTreeVisible(false);
        setType(type);
        setFormObject((prevstate) => ({
            ...prevstate,
            CodeType: type,
            // Code:checkedValue
        })
        );
        hForm.current &&
            hForm.current.setFieldsValue({
                CodeType: type,
                // Code:checkedValue
            });
    };

    const OnChangeModule = (Value) => {
        getHierarchyData(Value);
        setDisabled(false);
        setCheckedValue([]);
        setCode([]);
    };

    const onModalCancel = () => {
        if (code && Array.isArray(code) && code.length > 0) {
            setCheckedValue(code);
            setCode(code);
        } else {
            setCheckedValue([]);
        }
        let formId = hForm.current && hForm.current.getFieldsValue();

        if (!formId.Id && !code) {
            setType('Device');
        }
        setTreeVisible(false);

    };

    const hierarchyDropdownChange = (value) => {
        setCheckedValue(value);
        // setCode(data);
        // setFormObject((prevstate) => ({
        //     ...prevstate,
        //     // Code: value
        // })
        // );
        // hForm.current &&
        //     hForm.current.setFieldsValue({
        //         // Code: data
        //     });
    };

    const EquipmentModalOpen = async () => {
        setTreeVisible(true);
        setType('Device');
    };

    // const EquipmentModalOpen = async() =>{
    //     if (type === 'Asset'){
    //         const EquipmenList = await getAsset(checkedValue); 
    //         SetEquipmentList(EquipmenList);
    //     }else{
    //         const EquipmenList = await getDevice(checkedValue);
    //         SetEquipmentList(EquipmenList);
    //     }
    //         setTreeEquipmentVisible(true);
    // };
    const checkboxOnChange = async (SelectedValue) => {
        setType(SelectedValue);
        let form = hForm.current && hForm.current.getFieldsValue();

        if (form.code && form.code !== null && form.code !== undefined) {
            if (type !== SelectedValue && checkedValue.length !== 0) {
                setTypeChangeModal(true);
            } else {
                setType(SelectedValue);
            }
        } else {
            if (
                code &&
                Array.isArray(code) &&
                code.length > 0 &&
                type !== SelectedValue &&
                checkedValue.length !== 0
            ) {
                setTypeChangeModal(true);
            } else {
                setType(SelectedValue);
                setCheckedValue([]);
                setCode([]);
            }
        }

    };

    const onTypeChangeModalOk = () => {
        setType(type === 'Device' ? 'Asset' : 'Device');
        setTypeChangeModal(false);
        setCode([]);
        setCheckedValue([]);
    };
    const _getList = () => {
        const siteId = localStorage.get('currentSite');
        const accessToken = localStorage.get('accessToken');
        let url = `${API_PLANNEDHOURS.GET}?SiteId=${siteId}`;

        let orgHeaders = {
            method: 'GET',
            url,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };

        axios(orgHeaders)
            .then((response) => {
                setList(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    // const OnChangeType = async(value) =>{
    //     if(value === 'Asset'){
    //         const AssetType = await getAssetTypes();
    //         setDevicesList(AssetType);
    //     }else{
    //         const DeviceType = await getDeviceTypes();
    //         setDevicesList(DeviceType);
    //     }
    //     setType(value);
    // };

    // const OnChangeEquipmentType = async(value)=>{
    //     if (type === 'Asset'){
    //         const EquipmenList = await getAsset(value); 
    //         SetEquipmentList(EquipmenList);
    //     }else{
    //         const EquipmenList = await getDevice(value);
    //         SetEquipmentList(EquipmenList);
    //     }
    // };



    const _editRecord = async (editObject) => {

        const arrayOfStrings = Object.entries(editObject.PlannedHours).map(([key, value]) => `${key}: ${value} hours`);
        const datePlannedHours = editObject?.PlannedHoursExcluded ? editObject.PlannedHoursExcluded.map(({ StartDate, PlannedHours }) =>
            `${dayjs.utc(StartDate).format('YYYY-MM-DD')}: ${PlannedHours} hours`) : null;
        const codeType = editObject.CodeType;
        setType(codeType);
        setTitle('Update PlannedHours');

        let FormObject = {
            CodeType: editObject.CodeType,
            Code: editObject.Code,
            StartDate: dayjs.utc(editObject.StartDate),
            EndDate: dayjs.utc(editObject.EndDate),
            PlannedHours: arrayOfStrings,
            Comments: editObject.Comments,
            Id: editObject.Id,
            PlannedHoursExcluded: datePlannedHours,
            EditCount: editObject.EditCount,
            Status: editObject.Status,
            Type: editObject.Type,
        };
        setCode(editObject.Code);
        // setCheckedValue(editObject.Code);
        setDateplannedHours(editObject.PlannedHoursExcluded);
        setVisibleAttributes(true);
        setFormObject(FormObject);
        setPlannedHours(arrayOfStrings);

        if (hForm.current) {
            hForm.current.setFieldsValue({
                CodeType: editObject.CodeType,
                Code: editObject.Code,
                StartDate: dayjs(editObject.StartDate),
                EndDate: dayjs(editObject.EndDate),
                PlannedHours: arrayOfStrings,
                PlannedHoursExcluded: datePlannedHours,
                Comments: editObject.Comments,
            });
        }
    };

const _ViewRecord = async (ViewObject) => {

        const arrayOfStrings = Object.entries(ViewObject.PlannedHours).map(([key, value]) => `${key}: ${value} hours`);
        const datePlannedHours = ViewObject?.PlannedHoursExcluded ? ViewObject.PlannedHoursExcluded.map(({ StartDate, PlannedHours }) =>
            `${dayjs.utc(StartDate).format('YYYY-MM-DD')}: ${PlannedHours} hours`) : null;
        const codeType = ViewObject.CodeType;
        setType(codeType);
        setTitle('View PlannedHours');

        let FormObject = {
            CodeType: ViewObject.CodeType,
            Code: ViewObject.Code,
            StartDate: dayjs.utc(ViewObject.StartDate),
            EndDate: dayjs.utc(ViewObject.EndDate),
            PlannedHours: arrayOfStrings,
            Comments: ViewObject.Comments,
            Id: ViewObject.Id,
            PlannedHoursExcluded: datePlannedHours,
            EditCount: ViewObject.EditCount,
            Status: ViewObject.Status,
            Type: ViewObject.Type,
        };
        setCode(ViewObject.Code);
        // setCheckedValue(ViewObject.Code);
        setDateplannedHours(ViewObject.PlannedHoursExcluded);
        setVisibleAttributes(true);
        setFormObject(FormObject);
        setPlannedHours(arrayOfStrings);

        if (hForm.current) {
            hForm.current.setFieldsValue({
                CodeType: ViewObject.CodeType,
                Code: ViewObject.Code,
                StartDate: dayjs(ViewObject.StartDate),
                EndDate: dayjs(ViewObject.EndDate),
                PlannedHours: arrayOfStrings,
                PlannedHoursExcluded: datePlannedHours,
                Comments: ViewObject.Comments,
            });
        }
    };
    const onFinish = async (value) => {
        if (Object.keys(plannedHours) && Object.keys(plannedHours).length > 0) {
            hForm.current &&
                hForm.current
                    .validateFields()
                    .then(async (values) => {
                        let payload = {
                            Code: checkedValue || formObject.Code,
                            StartDate: dayjs(values.StartDate).format('YYYY-MM-DD 18:30:00'),
                            EndDate: dayjs(values.EndDate).format('YYYY-MM-DD 18:29:59'),
                            PlannedHours: plannedHours,
                            CodeType: type,
                            Comments: values.Comments,
                            PlannedHoursExcluded: dateplannedHours,
                            Status: value,
                            Type: formObject.Type,
                        };

                        if (formObject && formObject.Id) {
                            let UpdateResponse = await UpdatePlannedHours(
                                payload,
                                formObject.Id
                            );
                            if (UpdateResponse && UpdateResponse.message) {
                                message.success(UpdateResponse.message);
                            }
                        } else {
                            let createResponse = await CreatePlannedHours(payload);
                            if (createResponse && createResponse.message) {
                                message.success(createResponse.message);
                            }
                        }
                        _getList();
                        hForm.current &&
                            hForm.current.setFieldsValue({
                                Code: null,
                                Type: null,
                                StartDate: null,
                                EndDate: null,
                                PlannedHours: null,
                                Comments: null,
                                PlannedHoursExcluded: null
                            });
                        setFormObject({});
                        setVisibleAttributes(false);
                        // setCheckedValue([]);
                        setDateplannedHours([]);
                        setType('');
                        setPlannedHours({});
                    })
                    .catch((error) => {
                        console.log(error);
                    });
        } else {
            message.warning('Please Add atleast one PlannedHours');
        }
    };

    const OpenDrawer = () => {
        hForm.current &&
            hForm.current.setFieldsValue({
                CodeType: null,
                Code: null,
                Type: null,
                StartDate: null,
                EndDate: null,
                PlannedHours: null,
                Comments: null,
                PlannedHoursExcluded: null,
                module: null
            });


        getModuleList();
        setVisibleAttributes(true);
        setFormObject(formObject);
        setPlannedHours({});
        // setSelectedDeviceObject('');
        setCheckedValue([]);
        setCode([]);
        setTitle('');
        setClose(false);
        setDisabled(true);
    };



    const onClose = () => {
        hForm.current &&
            hForm.current.setFieldsValue({
                CodeType: null,
                Code: null,
                Type: null,
                Value: null,
                StartDate: null,
                EndDate: null,
                PlannedHours: null,
                Comments: null,
                PlannedHoursExcluded: null,
                module: null
            });
        setVisibleAttributes(false);
        setFormObject({});
        setPlannedHours([]);
        setDateplannedHours([]);
        setType('');
        setStatus(false);
        setCheckedValue([]);
        setCode([]);
        setTitle('');
        setClose(true);
        setDisabled(true);
    };



    const handleSearch = (selectedKeys, confirm) => {
        confirm();
        setSearchText(selectedKeys[0]);
    };

    const handleReset = (clearFilters, confirm) => {
        clearFilters();
        handleSearch([], confirm);
    };

    //   const handleChange = () => {
    //     setPopVisible(true); 
    //   };

    //   const handleConfirm = () => {
    //     setIsChecked(true);
    //     hForm?.current?.setFieldsValue({ EquipmentType: true }); 
    //     setPopVisible(false);
    //   };

    //   const handleCancel = () => {
    //     setIsChecked(false);
    //     hForm?.current?.setFieldsValue({ EquipmentType: false }); 
    //     setPopVisible(false);
    //   };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={"search"}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    onClick={() => handleSearch(selectedKeys, confirm)}
                    icon={<SearchOutlined />}

                    style={{ width: 90, marginRight: 8 }}
                >
                    {"search"}
                </Button>
                <Button
                    onClick={() => handleReset(clearFilters, confirm)}

                    style={{ width: 90 }}
                >
                    {"Reset"}
                </Button>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
        ),
        onFilter: (value, record) =>
            record &&
            record[dataIndex] &&
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: () => {
            setTimeout(() => searchInput.current.select());
        },
        render: (text) => (
            <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={text && text.toString()}
            />
        )
    });

    const columns = [
        {
            title: translation(translationCache, 'Type'),
            dataIndex: 'CodeType',
            key: 'CodeType',
            ...getColumnSearchProps('CodeType'),
        },
        {
            title: translation(translationCache, 'Equipment Type'),
            dataIndex: 'Type',
            key: 'Type',
            ...getColumnSearchProps('Type'),
        },
        {
            title: translation(translationCache, 'Equipment'),
            dataIndex: 'Code',
            key: 'Code',
            ...getColumnSearchProps('Code'),
        },
        {
            title: translation(translationCache, 'StartDate'),
            dataIndex: 'StartDate',
            key: 'StartDate',
            ...getColumnSearchProps('StartDate'),
        },
        {
            title: translation(translationCache, 'EndDate'),
            dataIndex: 'EndDate',
            key: 'EndDate',
            ...getColumnSearchProps('EndDate'),
        },
        {
            title: translation(translationCache, 'Status'),
            dataIndex: 'Status',
            key: 'Status',
            ...getColumnSearchProps('Status'),
        },
        {
            title: translation(translationCache, 'Action'),
            dataIndex: 'Action',
            render: (text, record) => (
                <>
                    {(record?.EditCount >= 2) || (record.Status === 'Submitted') ? null : (
                        <Button onClick={() => _editRecord(record)} style={{ marginRight: 8 }}>
                            <Tooltip title={translation(translationCache, "Edit")}>
                                <EditOutlined />
                            </Tooltip>
                        </Button>
                    )}

                    <Button onClick={() => _ViewRecord(record)} >
                        <Tooltip title={translation(translationCache, "View")}>
                            <EyeOutlined />
                        </Tooltip>
                    </Button>
                    {/* <Popconfirm
                        title={translation(translationCache, 'Are You Sure That You Want To Delete')}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => deleteRecord(record)}
                        okText={translation(translationCache, 'yes')}
                        cancelText={translation(translationCache, 'No')}
                    >
                        <Button >
                            <span>
                                <Tooltip title={translation(translationCache, 'Delete')}>
                                    <DeleteOutlined />
                                </Tooltip>
                            </span>
                        </Button>
                    </Popconfirm> */}
                </>
            )
        }
    ];

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'right', padding: '20px' }}>
                <Button type="primary" style={{
                    marginRight: '10px'
                }}
                    onClick={OpenDrawer}>
                    <PlusOutlined /> {translation(translationCache, 'Add Planned Hours')}
                </Button>

            </div>
            <StyledTable size="small"
                columns={columns}
                dataSource={list && Array.isArray(list) ? list : []}
                pagination={
                    list && Array.isArray(list) && list.length > 10
                        ? {
                            pageSize: '10'
                        }
                        : false
                }
            />
            <Drawer
                title={translation(translationCache,title) || translation(translationCache, 'Create Planned Hours')}
                placement="right"
                width={700}
                closable
                onClose={onClose}
                open={visibleAttributes}
            >
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 12 }}
                    layout="horizontal"
                    ref={hForm}
                    name="ParameterSelection"
                    initialValues={formObject}
                    onFinish={onFinish}
                >
                    {!formObject?.Id && (
                        <Form.Item
                            label={translation(translationCache, 'Module')}
                            name="module"
                            // rules={[{ required: true, message: 'Please select Module' }]}
                            style={{ marginBottom: 20 }}
                        >
                            <Select
                                placeholder={translation(translationCache, 'Select Module')}
                                onChange={(value) => OnChangeModule(value)}
                                disabled={formObject?.Id || status ? true : false}
                            >
                                {modulesList &&
                                    Array.isArray(modulesList) &&
                                    modulesList.map((device, key) => (
                                        <Option key={key} value={device.Code}>
                                            {translation(device.Code)}
                                        </Option>
                                    )
                                    )}
                            </Select>

                        </Form.Item>
                    )}


                    <Form.Item
                        label={translation(translationCache, 'Equipment')}
                        name="Code"
                        // rules={[
                        //     { required: true, message: translation(translationCache, 'Please select Equipment Type!') }
                        // ]}
                        style={{ marginBottom: 20 }}

                    >
                        {/* <Select 
                        placeholder={translation(translationCache,'Select Equipment Type')}
                        onChange={(value) => OnChangeEquipmentType(value)}
                        disabled={formObject?.Id ||status?true:false}
                        >
                        {devicesList &&
                            Array.isArray(devicesList) &&
                            devicesList.map((device, key) =>  (
                                <Option key={key} value={device.AliasCode}>
                                {translation(device.AliasCode)}
                                </Option>
                            )
                            )}
                        </Select> */}
                        <span style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <Select
                                mode='multiple'
                                value={code}
                                placeholder={translation(translationCache, 'Select Equipment Type')}
                                disabled={true}
                            >
                                {hierarchydata &&
                                    Array.isArray(hierarchydata) &&
                                    hierarchydata.map((device, index) => (
                                        <Option key={index} value={`${device.MultiAliasCode}`}>
                                            {device.DisplayCode}
                                        </Option>
                                    ))}
                            </Select>
                            <Button
                                style={{ width: '5%' }}
                                type="primary"
                                onClick={() => EquipmentModalOpen()}
                                disabled={formObject?.Id || disabled ? true : false}
                            >
                                <UpSquareOutlined />
                            </Button>
                        </span>
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Type')}
                        name="CodeType"
                        // rules={[{ required: true, message: 'Please select Type' }]}
                        style={{ marginBottom: 20 }}
                    >
                        <Input value={type} placeholder={translation(translationCache, 'Please select Type')} disabled={true} />
                    </Form.Item>
                    {/* <Form.Item
                        label={translation(translationCache, 'Equipment Type')}
                        name="EquipmentType"
                        // rules={[
                        // {
                        //     required: true,
                        //     message: translation(translationCache, 'Please select Equipment Type!'),
                        // },
                        // ]}
                        valuePropName="checked"
                        style={{marginBottom:20}}
                    >
                        <Popconfirm
                        title={translation(
                            translationCache,
                            'You have selected to apply the planned hours to all the selected equipment type. Are you sure you want to proceed ?'
                        )}
                        visible={popVisible}
                        onConfirm={handleConfirm}
                        onCancel={handleCancel}
                        okText={translation(translationCache, 'Ok')}
                        cancelText={translation(translationCache, 'Cancel')}
                        >
                        <Checkbox
                            checked={isChecked}
                            onChange={handleChange}
                            disabled={formObject?.Id ||disabled? true : false}
                        />
                        </Popconfirm>
                    </Form.Item> */}
                    <Form.Item

                        name="StartDate"
                        label={translation(translationCache, 'Start Date')}
                        // rules={[{ required: true }]}
                        style={{ marginBottom: 20 }}
                    >
                        <DatePicker
                            disabled={formObject?.Id || status || disabled ? true : false}
                            placeholder={translation(translationCache, 'Select Start Date')}
                            allowClear={false}
                            format="YYYY-MM-DD"
                            disabledDate={(d) => !d || d.isBefore(hForm.current?.getFieldValue('EndDate'))}
                        />
                    </Form.Item>
                    <Form.Item
                        name="EndDate"
                        label={translation(translationCache, 'End Date')}
                        // rules={[{ required: true }]}
                        style={{ marginBottom: 20 }}
                    >
                        <DatePicker
                            disabled={formObject?.Id || status || disabled ? true : false}
                            placeholder={translation(translationCache, 'Select End Date')}
                            allowClear={false}
                            format="YYYY-MM-DD"
                            disabledDate={(d) => !d || d.isBefore(dayjs(hForm.current?.getFieldValue('StartDate')).add(1, 'day'))}
                        />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Planned hrs Per Day')}
                        name="PlannedHours"
                        style={{ marginBottom: 20 }}
                    >
                        <PlannedHoursForm
                            value={plannedHours && Object.entries(plannedHours).map(
                                ([day, hours]) => `${day}: ${hours} hours`
                            )}
                            addedTagList={addedTagList}
                            closeTagList={closeTagList}
                            formObject={formObject}
                            disabled={status}
                            formEnabled={disabled}
                            {...props}
                            close={close}
                        />

                    </Form.Item>

                    {formObject && formObject.Id && (
                        <>
                            <Form.Item
                                label={translation(translationCache, 'DateSelection')}
                                name="PlannedHoursExcluded"
                                style={{ marginBottom: 20 }}
                            >
                                <DatePlannedHours
                                    value={dateplannedHours && Array.isArray(dateplannedHours) && dateplannedHours.map(({ StartDate, PlannedHours }) =>
                                        `${dayjs(StartDate).format('YYYY-MM-DD')}: ${PlannedHours} hours`
                                    )}
                                    formObject={formObject}
                                    addedTagList={addedDateTagList}
                                    closeTagList={(newList) => closeDateTagList(newList)}
                                    startDate={formObject.StartDate}
                                    endDate={formObject.EndDate}
                                    disabled={status}
                                />

                            </Form.Item>
                            <Form.Item
                                label={translation(translationCache, 'Comments')}
                                name='Comments'
                                style={{ width: '100%', flex: '50%', marginBottom: 20 }}
                            >
                                <TextArea
                                    rows={3}
                                    placeholder={translation(translationCache, 'Enter Comments')}
                                    disabled={(formObject?.EditCount >= 2) || (formObject.Status === 'Submitted') || status ? true : false}
                                />
                            </Form.Item>
                        </>
                    )}
                    <Modal
                        open={typeChangeModal}
                        // onOk={onModalsOk}
                        // okText={'Ok'}
                        onCancel={() => setTypeChangeModal(false)}
                        footer={[
                            <Button key="back" onClick={() => setTypeChangeModal(false)}>
                                No
                            </Button>,
                            <Button key="submit" onClick={onTypeChangeModalOk}>
                                Yes
                            </Button>
                        ]}>
                        Are you want to change the option. If you try to change the option, you will lose data
                    </Modal>
                    <Modal
                        open={treeVisible}
                        width={800}
                        closable
                        title={'Select Equipment Type'}
                        okText={'Add'}
                        onOk={onModalsOk}
                        onCancel={onModalCancel}
                    >
                        <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                            <Checkbox
                                checked={type === 'Device'}
                                onChange={() => checkboxOnChange('Device')}
                            >
                                Device
                            </Checkbox>
                            <Checkbox
                                checked={type === 'Asset'}
                                onChange={() => checkboxOnChange('Asset')}
                            >
                                Asset
                            </Checkbox>
                        </div>
                        <HierarchyModal
                            treeData={Object.values(hierarchydata)}
                            Key="EquipmentType"
                            handleDropdownChange={hierarchyDropdownChange}
                            selectedOption={type}
                            checkedArray={checkedValue ? checkedValue : []}
                        />
                    </Modal>

                </Form>
                <DrawerFooter>
                    <Button type="primary" onClick={onClose} style={{ marginRight: 8 }}>
                        {translation(translationCache, 'Cancel')}
                    </Button>
                    {(formObject?.EditCount >= 2) || (formObject.Status === 'Submitted') || status ? null : (
                        <>
                            <Button
                                type="primary"
                                onClick={() => {
                                    onFinish('Saved');
                                }}
                                style={{ marginRight: 8 }}
                            >
                                {translation(translationCache, 'Save')}
                            </Button>


                            <Button
                                type="primary"
                                onClick={() => {
                                    onFinish('Submitted');
                                }}
                            >
                                {translation(translationCache, 'Submit')}
                            </Button>
                        </>
                    )}
                </DrawerFooter>
            </Drawer>
        </>
    );
};

const mapStateToProps = (state) => ({
    translationCache: state.TranslationReducer.translationCache,
    defaultHiearchy: state.LayoutReducer.DefaultHierarchy
});

export default connect(mapStateToProps)(ParameterSelection);

